"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uuid = require("uuid");
var _axios = _interopRequireDefault(require("axios"));
var _createHash = _interopRequireDefault(require("create-hash"));
var _ApplicationContext = require("../ApplicationContext");
var _MessageResolver = require("../MessageResolver");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
const processResults = (listener, stepListener, controller) => {
  /**
   * 1. If there is a failure, let the main Login page know
   * 2. If it is successful/complete authentication help with login, let the main login page know
   * 3. If the step was successful, let the main login page know the next step
   * 4. If the step had an error, let the step handler know the error message
   */
  if (controller.isFailure()) {
    listener.setState({
      authFailure: true,
      statusCode: controller.getStatusCode(),
      message: controller.getMessage()
    });
  } else if (controller.isComplete()) {
    const completeMessage = /*#__PURE__*/_react.default.createElement("div", {
      className: "columns is-mobile"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-1"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "help is-success material-icons is-size-1"
    }, "info"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-11 pl-6 mt-3 is-size-5"
    }, /*#__PURE__*/_react.default.createElement(_MessageResolver.MessageResolver, {
      statusCode: controller.getStatusCode(),
      message: controller.getMessage()
    })));
    stepListener.setState({
      message: completeMessage,
      workflowComplete: true,
      isLoading: false
    });
  } else if (controller.wasStepSuccessful()) {
    // eslint-disable-next-line no-console
    listener.setState({
      authComponent: controller.getNextStep()
    });
  } else {
    const errorMessage = /*#__PURE__*/_react.default.createElement("div", {
      className: "columns is-mobile"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-1"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon has-text-warning"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons is-size-1"
    }, "warning"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-11 "
    }, /*#__PURE__*/_react.default.createElement(_MessageResolver.MessageResolver, {
      statusCode: controller.getStatusCode(),
      message: controller.getMessage()
    })));
    stepListener.setState({
      errorMessage,
      rawErrorMessage: controller.getMessage(),
      isLoading: false
    });
  }
};
var _request = /*#__PURE__*/new WeakMap();
var _listener = /*#__PURE__*/new WeakMap();
var _codeVerifier = /*#__PURE__*/new WeakMap();
var _stepResponse = /*#__PURE__*/new WeakMap();
class AuthenticationHelpController {
  constructor(listener) {
    _classPrivateFieldInitSpec(this, _request, null);
    _classPrivateFieldInitSpec(this, _listener, null);
    _classPrivateFieldInitSpec(this, _codeVerifier, null);
    _classPrivateFieldInitSpec(this, _stepResponse, null);
    _classPrivateFieldSet(_listener, this, listener);
    _classPrivateFieldSet(_request, this, _axios.default.create({
      baseURL: _ApplicationContext.ApplicationContext.getApiBasePath()
    }));
  }
  initialize(stepListener) {
    const currentChallengeUUID = (0, _uuid.v4)();
    _classPrivateFieldSet(_codeVerifier, this, (0, _createHash.default)('sha256').update(currentChallengeUUID).digest('base64'));
    const formData = new FormData();
    formData.append('client_id', _ApplicationContext.ApplicationContext.getClientId());
    formData.append('code_challenge', currentChallengeUUID);
    formData.append('code_challenge_method', 'S256');
    _classPrivateFieldGet(_request, this).post('/security/auth/help/initialize', formData).then(results => {
      _classPrivateFieldSet(_stepResponse, this, results.data);
      processResults(_classPrivateFieldGet(_listener, this), stepListener, this);
    }).catch(() => {
      _classPrivateFieldSet(_stepResponse, this, {
        message: 'Unable to perform authentication help at this time.  Please try again later.',
        stepStatus: 'FAILED',
        workflowStatus: 'FAILED'
      });
      processResults(_classPrivateFieldGet(_listener, this), stepListener, this);
    });
  }
  proceed(stepListener, step) {
    step.setCodeVerifier(_classPrivateFieldGet(_codeVerifier, this));
    step.setContextId(_classPrivateFieldGet(_stepResponse, this).contextId);
    _classPrivateFieldGet(_request, this).post('/security/auth/help/continue', step).then(results => {
      _classPrivateFieldSet(_stepResponse, this, results.data);
      processResults(_classPrivateFieldGet(_listener, this), stepListener, this);
    }).catch(() => {
      _classPrivateFieldSet(_stepResponse, this, {
        message: 'Unable to perform authentication help at this time.  Please try again later.',
        stepStatus: 'FAILED',
        workflowStatus: 'FAILED'
      });
      processResults(_classPrivateFieldGet(_listener, this), stepListener, this);
    });
  }
  getCodeVerifier() {
    return _classPrivateFieldGet(_codeVerifier, this);
  }
  isFailure() {
    return _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).workflowStatus === 'FAILED' : false;
  }
  isComplete() {
    return _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).workflowComplete : false;
  }
  wasStepSuccessful() {
    return _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).stepSuccessful : false;
  }
  getStatusCode() {
    return _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).statusCode : null;
  }
  getNextStep() {
    return _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).nextStep : 'InitializeAuthenticationHelp';
  }
  getMessage() {
    return _classPrivateFieldGet(_stepResponse, this) ? _classPrivateFieldGet(_stepResponse, this).message : null;
  }
  getStepResponse() {
    return _classPrivateFieldGet(_stepResponse, this);
  }
}
var _default = exports.default = AuthenticationHelpController;
//# sourceMappingURL=AuthenticationHelpController.js.map